/**
 * Product scope — Gate 1+ features (readiness, trust weights, risk register, etc.).
 */
export const POST_GATE0_FEATURES_ENABLED = true;

export function postGate0FeaturesEnabled() {
  return POST_GATE0_FEATURES_ENABLED;
}

/**
 * Gate 0 Application Configuration (/framework/:projectId) — Add/Edit sections & questions.
 * When false, the page is view-only for structure (Delete and Next remain available).
 * Does not affect platform Tenant Template Configuration.
 */
export const CONFIGURATION_EDIT_ENABLED = false;

export function configurationEditEnabled() {
  return CONFIGURATION_EDIT_ENABLED;
}

/** Keep gate tab bar on Gate 0 when post-Gate-0 features are off. */
export function effectiveUnlockedGateIndex(unlockedUpTo = 0) {
  if (POST_GATE0_FEATURES_ENABLED) return unlockedUpTo;
  return Math.min(unlockedUpTo, 0);
}
